module.exports = __webpack_public_path__ + "img/Sponga_loading.b5b7eea3.gif";